import React from 'react';
import PropTypes from 'prop-types';
import { LabelWithBackground, TableEmptyData } from 'modules/Core/Common';
import { PendingIcon } from '@edusynch/edusynch-svg-icons';

import * as S from './LevelLabels.styles';

const PENDING_STATUS = 'Pending Evaluation';

export const LevelLabels = ({ label, status }) => {
  if (status === PENDING_STATUS) {
    return (
      <S.PendingIconContainer>
        <PendingIcon color="#0075EA" width={18} height={18} />
      </S.PendingIconContainer>
    );
  }

  return (
    <S.Label>
      {label ? (
        <LabelWithBackground secondary autoSize label={label} />
      ) : (
        <TableEmptyData />
      )}
    </S.Label>
  );
};

LevelLabels.propTypes = {
  status: PropTypes.string,
  label: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.node,
  ]),
};
